export var SnackbarPosition;
(function (SnackbarPosition) {
    SnackbarPosition["Top"] = "top";
    SnackbarPosition["Bottom"] = "bottom";
})(SnackbarPosition || (SnackbarPosition = {}));
